module.exports = __webpack_public_path__ + "884bb3f0be4ae549f7fea1e6b5681ed6.mp4";